
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class RepairItemsBOMDialog extends _Ext.BOMEditorDialog<RepairItemsBOMRow> { 
        protected getLocalTextPrefix() { return RepairItemsBOMRow.localTextPrefix; }
        protected getDeletePermission() { return RepairItemsBOMRow.deletePermission; }
        protected getInsertPermission() { return RepairItemsBOMRow.insertPermission; }
        protected getUpdatePermission() { return RepairItemsBOMRow.updatePermission; } 
        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            opt.ShowSaveAndNewButtonInToolbar = false;
            opt.ShowDeleteButton = false;
            return opt;
        }

        constructor() {
            super();
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.PointerWeight);
            q.setTextRightAlign(this.form.BomAmount);
            q.setTextRightAlign(this.form.BomRate);
            q.setTextRightAlign(this.form.Purity);
            q.setTextRightAlign(this.form.Purity);

            // Module Configuration
            this.UseKaratWiseRate = q.ToBool(TabAurous.GetConfigValue(1014));  

            this.form.BomRate.changeSelect2(e => {
                var calcon = this.form.CalcOnId.value;
                if (calcon == "4" || calcon == "5")
                    if (this.form.ItemTypeId.value == 104) {
                        if (this.UseKaratWiseRate == true)
                            this.form.BomAmount.value = this.form.BomRate.value * this.form.Weight.value || 0;
                        else
                            this.form.BomAmount.value = this.form.BomRate.value * this.form.Weight.value * this.form.Purity.value || 0;
                    }
                    else {
                        this.form.BomAmount.value = this.form.BomRate.value * this.form.Weight.value;
                    }
                if (calcon == "3")
                    this.form.BomAmount.value = this.form.BomRate.value * this.form.Pieces.value;

                this.form.CCBomAmount.value = this.form.BomAmount.value * this.ExchangeRate;

            });
        }
        
        afterLoadEntity() {
            super.afterLoadEntity();
            ItemFieldHelper.SalesBOMFields(this);
        }

        protected validateBeforeSave() {
            this.entity.RefTransBomId === undefined ? this.entity.RefTransBomId = 0 : this.entity.RefTransBomId;
            return true;
        }
    }
}